import axios from 'axios';

const adminUrl = process.env.VUE_APP_ADMIN_URL;

export default class SponsorshipService {
  static getHeaders() {
    const accessToken = JSON.parse(localStorage.getItem('accessToken'));
    return { Authorization: `Bearer ${accessToken}` };
  }

  static async getMetrics(startDate, endDate) {
    try {
      const response = await axios.get(`${adminUrl}/sponsorships/metrics`, {
        headers: this.getHeaders(),
        params: { startDate, endDate }
      });
      if (response.status === 204 || !response.data || !response.data.data) {
        return { status: 'ok', data: { summary: { totalDirectSponsorships: 0, totalSolidarioPlans: 0 }, timeSeries: [] } };
      }
      return { status: 'ok', data: response.data.data };
    } catch (error) {
      return { status: 'error', message: error?.response?.data?.message || 'Error al obtener métricas' };
    }
  }

  static async getRankingByCompany() {
    try {
      const response = await axios.get(`${adminUrl}/sponsorships/ranking/by-company`, {
        headers: this.getHeaders()
      });
      if (response.status === 204 || !response.data || !response.data.data) {
        return { status: 'ok', data: [] };
      }
      return { status: 'ok', data: response.data.data };
    } catch (error) {
      return { status: 'error', message: error?.response?.data?.message || 'Error al obtener el ranking' };
    }
  }

  static async getExportedMembershipsExcel(companyId) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const url = `${adminUrl}/sponsorships/${companyId}/export`;
      const params = {};
      if (companyId && companyId.length !== 0) {
        params.companyId = companyId;
      }
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${accessToken}` },
        params: params,
        responseType: 'blob'
      });

      if (response.status === 200) {
        // Crear un Blob a partir de la respuesta
        const blob = new Blob([response.data], {
          type: response.headers['content-type']
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;

        // Obtener el nombre de archivo desde el encabezado 'Content-Disposition', si está presente
        const contentDisposition = response.headers['content-disposition'];
        let fileName = 'sponsorships.xlsx';
        if (contentDisposition) {
          let fileNameMatch = contentDisposition.match(/filename\*?=(['"])(.*?)\1/);
          if (fileNameMatch && fileNameMatch.length >= 3) {
            fileName = fileNameMatch[2];
          } else {
            // Intentar con otro patrón
            fileNameMatch = contentDisposition.match(/filename\*?=([^;]+)/);
            if (fileNameMatch && fileNameMatch.length >= 2) {
              fileName = fileNameMatch[1].trim();
            }
          }
        }

        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(downloadUrl);

        return { status: 'ok', success: true };
      } else {
        throw new Error(`Error al descargar el archivo: ${response.statusText}`);
      }
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
      throw error;
    }
  }

  // Cambia la mascota apadrinada (p.ej. porque la anterior fue adoptada). El plan y el cobro no cambian.
  static async changeShelterPet(sponsorshipId, shelterPetId) {
    try {
      await axios.patch(
        `${adminUrl}/sponsorships/${sponsorshipId}/shelter-pet`,
        { shelterPetId },
        { headers: this.getHeaders() }
      );
      return { status: 'ok' };
    } catch (error) {
      return { status: 'error', message: error?.response?.data?.message || 'No se pudo cambiar la mascota' };
    }
  }

  // Activa (2) o desactiva (4) el apadrinamiento; desactivar exige motivo. No toca el cobro en MP/Stripe.
  static async changeStatus(sponsorshipId, status, deactivationReason) {
    try {
      await axios.patch(
        `${adminUrl}/sponsorships/${sponsorshipId}/status`,
        { status, deactivationReason },
        { headers: this.getHeaders() }
      );
      return { status: 'ok' };
    } catch (error) {
      return { status: 'error', message: error?.response?.data?.message || 'No se pudo cambiar el estado' };
    }
  }

  static async getStatusHistory(sponsorshipId) {
    try {
      const response = await axios.get(`${adminUrl}/sponsorships/${sponsorshipId}/status-history`, {
        headers: this.getHeaders()
      });
      return { status: 'ok', data: response.data.data || [] };
    } catch (error) {
      return { status: 'error', message: error?.response?.data?.message || 'No se pudo cargar el historial' };
    }
  }
}
